<style lang="scss" scoped>
    .neon-title {
        font-size: toRem(30px);
        line-height: lh(41px, 30px);
        letter-spacing: 21.6px;
        text-transform: uppercase;
        margin-bottom: 50px;

        @include above(md) {
            font-size: toRem(60px);
            line-height: lh(82px, 60px);
        }
    }
</style>
<template>
    <div class="neon-title" :style="{color, textShadow: `0 0 5px ${color}`}">{{ title }}</div>
</template>
<script>
export default {
    name: 'NeonTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
}
</script>
